import { FEEDBACK_UNKNOWN_FAILURE } from './global_variables';

const MAX_MESSAGE_LENGTH = 200;
const DEFAULT_TRACKING_ID = 'unknown tracking ID';

const validateMessage = (message: string): boolean => {
  const illegal_chars = /[{}[\]#$%^&*()/<>`=\\]/;
  const is_valid: boolean =
    !illegal_chars.test(message) && !!message.trim() && message.length < MAX_MESSAGE_LENGTH;
  return is_valid;
};

const getSafeMessage = (message: string, tracking_id?: string | null): string => {
  const trace_id: string = tracking_id ? tracking_id : DEFAULT_TRACKING_ID;
  const default_error_message: string = FEEDBACK_UNKNOWN_FAILURE(trace_id);
  return validateMessage(message) ? message : default_error_message;
};

export default getSafeMessage;
